import React, { useEffect, useState, useMemo } from "react";
import DataTable from "react-data-table-component";
import { useForm, Controller } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";

function FormApiAction() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const [navForApiData, setnavForApiData] = useState([]);
  const [navFormApiMethodData, setnavFormApiMethodData] = useState([]);
  const [triggerRerender, setTriggerRerender] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const {
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    setValue,
    getValues,
    trigger,
    register,
    reset,
  } = useForm({
    defaultValues: {
      centerId: "",
    },
  });

  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [selectedAssignBtnIds, setselectedAssignBtnIds] = useState([]);
  const [centersData, setCentersData] = useState([]);
  const [AssignAlertSelectError, setAssignAlertSelectError] = useState("");
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");
  const [selectedFormId, setSelectedFormId] = useState("");
  const [alertNotificationButton, setAlertNotificationButton] = useState([]);

  const getNavApiFormList = async (subCategoryId) => {
    if (!token || !subCategoryId) return;
    try {
      const formdata = { id: subCategoryId };
      const response = await post(
        `UserAuthentication/GetAllNavForm`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setnavForApiData(response);
    } catch (error) {
      console.error("Error fetching nav forms:", error);
    }
  };
  const getNavApiFormMethodList = async (selectedOption, actionMeta) => {
    setValue(`FormId`, selectedOption || { value: 0, label: "" });
    const formId = getValues(`FormId`) ? getValues(`FormId`).value : null;
    if (!token || !formId) return;
    try {
      const formdata = { id: formId };
      const response = await post(
        `UserAuthentication/GetAllNavFormApiMehod`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setnavFormApiMethodData(response);
    } catch (error) {
      console.error("Error fetching nav forms:", error);
    }
  };
  const handleEditClick = async (rowId) => {
    var formData = { id: rowId };
    try {
      const response = await post(
        `UserAuthentication/GetNavFormApiMehodById`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const selectedNavForm = response;

      const selectedCategory = categoryData.find(
        (option) => option.id === response.subCategoryFormId
      );

      const selectedSubCategory = subCategoryData.find(
        (option) => option.id === response.formSubCategoriesId
      );

      reset({
        id: selectedNavForm.id,
        name: selectedNavForm.name,
        formPath: selectedNavForm.formPath,
        formCategoryId: selectedCategory
          ? { value: selectedCategory.id, label: selectedCategory.name }
          : null,
        FormSubCategoriesId: selectedSubCategory
          ? { value: selectedSubCategory.id, label: selectedSubCategory.name }
          : null,
      });

      setSelectedCategoryId(selectedCategory?.id || "");
      setSelectedSubCategoryId(selectedSubCategory?.id || "");
    } catch (error) {
      console.error("Error fetching navform:", error);
    }
  };

  const handleDeleteClick = async (rowId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Form?"
    );

    if (confirmDelete) {
      const formdata = { id: rowId };
      try {
        const response = await post(
          `UserAuthentication/DeleteNavFormApiMehod`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        getNavApiFormList(selectedSubCategoryId);
      } catch (error) {
        console.error("Error deleting navform:", error);
      }
    }
  };
  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      omit: false,
    },
    {
      name: "Name",
      selector: (row) => `${row.name}`,
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <>
          <div className="d-flex gap-1">
            <button
              type="button"
              className="btn p-0"
              onClick={() => handleEditClick(row.id)}
            >
              <i className="fas fa-pencil"></i>
            </button>
            <button
              type="button"
              className="btn p-0"
              onClick={() => handleDeleteClick(row.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        </>
      ),
    },
  ];
  const handleCategoryChange = (selectedOption, actionMeta) => {
    if (actionMeta.action === "clear") {
      setValue(`formCategoryId`, null);
      setSelectedCategoryId("");
      setSelectedSubCategoryId(null); // Reset subcategory only if category is cleared
    } else {
      setValue(`formCategoryId`, selectedOption || { value: 0, label: "" });
      setSelectedCategoryId(selectedOption?.value);
    }
    trigger(`formCategoryId`);
  };
  const getCategories = async () => {
    if (!token) return;
    try {
      const response = await get("UserAuthentication/GetAllCategory", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCategoryData(response.navCategory);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  useEffect(() => {
    getCategories();
  }, [triggerRerender]);
  useEffect(() => {
    if (selectedCategoryId) {
      getSubCategoryList(selectedCategoryId);
    } else {
      setSubCategoryData([]);
    }
  }, [selectedCategoryId, triggerRerender]);
  useEffect(() => {
    if (selectedSubCategoryId) {
      getNavApiFormList(selectedSubCategoryId);
    } else {
      setnavForApiData([]);
    }
  }, [selectedSubCategoryId, triggerRerender]);
  const getSubCategoryList = async (categoryId) => {
    if (!token || !categoryId) return;
    try {
      const formdata = { formCategoryId: categoryId };
      const response = await post(
        `UserAuthentication/GetAllNavSubCategory`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setSubCategoryData(response);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };
  const handleSubCategoryChange = (selectedOption, actionMeta) => {
    if (actionMeta.action === "clear") {
      setValue(`FormSubCategoriesId`, null);
      setSelectedFormId(null);
    } else {
      setValue(
        `FormSubCategoriesId`,
        selectedOption || { value: 0, label: "" }
      );
      setValue(`FormId`, null);
      setSelectedSubCategoryId(selectedOption?.value);
    }
    trigger(`FormSubCategoriesId`);
  };
  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const formdata = {
      ...data,
      formCategoryId: data?.formCategoryId?.value,
      FormSubCategoriesId: data?.FormSubCategoriesId?.value,
      FormId: data?.FormId?.value,
      // formCategoryId: selectedCategoryId,
      // FormSubCategoriesId: selectedSubCategoryId,
    };

    // console.log(formdata);
    // return;

    try {
      const response = await post(
        `UserAuthentication/AddUpdateNavFormApiMehod`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);

        reset({
          id: 0,
          name: "",
          formCategoryId: {
            value: selectedCategoryId,
            label:
              categoryData.find((cat) => cat.id === selectedCategoryId)?.name ||
              "",
          },
          FormSubCategoriesId: {
            value: selectedSubCategoryId,
            label:
              subCategoryData.find(
                (subCat) => subCat.id === selectedSubCategoryId
              )?.name || "",
          },
        });
      }
    } catch (error) {
      console.error("Error saving subcategory:", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Api Form</h2>
      </div>

      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">
                    Category<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`formCategoryId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={categoryData.map((category) => ({
                          value: category.id,
                          label: category.name,
                        }))}
                        onChange={handleCategoryChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.formCategoryId && (
                    <small className="text-danger">
                      {errors.formCategoryId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Sub Category<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`FormSubCategoriesId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={subCategoryData.map((subCategory) => ({
                          value: subCategory.id,
                          label: subCategory.name,
                        }))}
                        onChange={handleSubCategoryChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.FormSubCategoriesId && (
                    <small className="text-danger">
                      {errors.FormSubCategoriesId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Form<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`FormId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={navForApiData.map((form) => ({
                          value: form.id,
                          label: form.name,
                        }))}
                        onChange={getNavApiFormMethodList}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.FormSubCategoriesId && (
                    <small className="text-danger">
                      {errors.FormSubCategoriesId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Api Name<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`Name`, {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                  />
                  {errors.apiName && (
                    <small className="text-danger">
                      {errors.apiName.message}
                    </small>
                  )}
                </div>
                <div className="col-md-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <DataTable
                columns={columns}
                data={navFormApiMethodData}
                pagination
                dense
                customStyles={customTableStyles}
                highlightOnHover={true}
              />
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
export default FormApiAction;
